<template>
    <div v-if="config">

    </div>
</template>

<script>
export default {
    props: ["config"],
    data: () => ({
        
    }),
    methods: {

    }
};
</script>